<template>
  <!-- 测试数据策略 报销申请 -->
  <div>
    <mrc_ess_table
      :headers="headers"
      v-if="$route.name == 'mrc_ess_Reimbursement'"
      pageName="mrc_ess_Reimbursement-add"
      :paginationOptions="paginationOptions"
      @turnPage="getList"
      :isLoading="loading"
      :items="desserts"
      :slotKey="[
        'reimbursement_datetime',
        'costs_produce_datetime',
        'staff_uuid',
        'department_uuid',
      ]"
    >
      <template v-slot:item.staff_uuid="{ item }">
        <mrc_ess_prompt
          :disabled="true"
          view
          v-model="item.staff_uuid"
          :select_arr="staffArr"
        ></mrc_ess_prompt>
      </template>
      <template v-slot:item.department_uuid="{ item }">
        <mrc_ess_prompt
          view
          :disabled="true"
          v-model="item.department_uuid"
          :select_arr="unitArr"
        ></mrc_ess_prompt>
      </template>
      <template v-slot:item.reimbursement_datetime="{ item }">
        {{ item.reimbursement_datetime | changeDate() }}
      </template>
      <template v-slot:item.costs_produce_datetime="{ item }">
        {{ item.costs_produce_datetime | changeDate() }}
      </template>
      <template v-slot:item.actions="{ item }">
        <menu-list :list="list" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon>mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getTestclaim_expenseList, delClaim } from "@/service/api/data-access-strategy";
import { getBusinessList } from "@/service/api/prompt";
export default {
  components: {},
  props: {},
  data() {
    return {
      unitArr: [],
      staffArr: [],
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      loading: false,
      desserts: [],
    };
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {},
  async mounted() {
    if (this.$route.name == "mrc_ess_Reimbursement") {
      const res = await getBusinessList({
        prompt_name: "show_name",
      });
      if (res.code == 200) {
        this.staffArr = res.data;
      } else {
        this.$Message({ text: "员工姓名参照未获取到，请刷新页面重新获取" });
      }
      const res1 = await getBusinessList({
        prompt_name: "unit",
      });
      if (res1.code == 200) {
        this.unitArr = res1.data;
      } else {
        this.$Message({ text: "公司参照未获取到，请刷新页面重新获取" });
      }
      await this.getList();
    }
  },
  beforeDestroy() {},
  methods: {
    /**
     * @description: 获取角色列表
     * @param {type}
     * @return:
     * @author: lwq
     */
    async getList(obj) {
      if (obj) {
        this.paginationOptions = obj;
      }
      this.loading = true;
      const list = await getTestclaim_expenseList({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
      });
      if (list.code == 200) {
        this.desserts = list.data;
        this.paginationOptions.totalcount = list.totalcount;
        this.paginationOptions.totalpage = list.totalpage;
      }
      this.loading = false;
    },
    /**
     * @description: 进入详情
     * @param {index} 点的第几个menu
     * @param {item} 点的整条数据
     * @return:
     * @author: lwq
     */
    handleClick({ item, index }, obj) {
      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            const del = await delClaim({
              uuid: obj.uuid,
            });
            if (del.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              });
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (this.desserts.length === 1 && this.paginationOptions.cpage > 1) {
                this.paginationOptions.cpage--;
              }
              await this.getList();
            }
          })
          .catch(() => {});
      }
    },
    /**
     * @description: 去添加页面
     * @param {type}
     * @return:
     * @author: lwq
     */
    handleAdd() {
      this.$router.push({
        name: "test-data-access-strategy-add",
      });
    },
  },
  computed: {
    list() {
      return [
        {
          name: this.$t("label_delete"),
          show: true,
          type: "del",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("部门"),
          align: "start",
          sortable: false,
          value: "department_uuid",
        },
        {
          text: this.$t("报销日期"),
          align: "start",
          sortable: false,
          value: "reimbursement_datetime",
        },
        {
          text: this.$t("姓名"),
          align: "start",
          sortable: false,
          value: "staff_uuid",
        },
        {
          text: this.$t("费用发生日期"),
          align: "start",
          sortable: false,
          value: "costs_produce_datetime",
        },
        {
          text: this.$t("合计"),
          align: "start",
          sortable: false,
          value: "total_amount",
        },
        // {
        //   text: ' ',
        //   align: 'end',
        //   sortable: false,
        //   value: 'actions',
        // },
      ];
    },
  },
  watch: {
    async $route(val) {
      if (val.name == "mrc_ess_Reimbursement") {
        await this.getList();
        this.$store.commit("setTab", 0);
      }
    },
  },
};
</script>

<style scoped>
.role_name {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}
.name {
  font-size: 16px;
}
.desc {
  width: 160px;
  color: #afabab;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.org_level_name {
  overflow: hidden;
  padding: 10px;
  white-space: nowrap;
  max-width: 30vw;
}
</style>
